(()=>{
 const behaviorFailure=root=>{try{window.ElookusBehaviorV1?.failed?.(root.hasAttribute("data-elookus-tryon-card")?"collection":"product","assets_or_dialog");}catch{}};
 if(window.__elookusTryonLoader)return;window.__elookusTryonLoader=true;
 const instances=new Map(),disposedRoots=new WeakSet(),modules=new Map(),styles=new Map(),configs=new WeakMap(),moduleRetryUsed=new Set(),moduleRetryExhausted=new Map();
 let current=null,lifecycle=0,openTicket=0,pageActive=true;
 const readConfig=root=>{if(!configs.has(root))configs.set(root,JSON.parse(root.querySelector('[data-elookus-tryon-config]').textContent));return configs.get(root);};
 const resolveFrame=(root,config)=>{
  if(!config.frames)return undefined;
  let variantId;
  if(root.hasAttribute('data-elookus-tryon-card'))variantId=root.dataset.variantId||String(config.initialVariantId);
  else{
   const section=root.closest('.shopify-section'),selected=section?.querySelector('.js-option[data-variant-id]:checked'),input=section?.querySelector('form[data-product-id="'+config.productId+'"] [name="id"]');
   variantId=selected?String(selected.dataset.variantId):input?String(input.value):new URL(location.href).searchParams.get('variant')||String(config.initialVariantId);
  }
  return config.frames.find(frame=>String(frame.variantId)===variantId&&frame.src)||null;
 };
 const syncCard=root=>{try{const button=root.querySelector('[data-elookus-tryon-open]');button.hidden=!resolveFrame(root,readConfig(root));}catch{}};
 const syncCards=()=>document.querySelectorAll('[data-elookus-tryon-card]').forEach(syncCard);
 const selectSwatch=event=>{
  const swatch=event.target.closest('[data-elookus-variant-id]');if(!swatch)return;
  if(event.type==='mouseover'&&swatch.contains(event.relatedTarget))return;
  const root=swatch.closest('product-block')?.querySelector('[data-elookus-tryon-card]');if(!root)return;
  root.dataset.variantId=swatch.dataset.elookusVariantId;syncCard(root);
 };
 document.addEventListener('mouseover',selectSwatch);
 document.addEventListener('click',selectSwatch,true);
 const cleanup=()=>{for(const[root,entry]of instances)if(!root.isConnected){entry.disposed=true;entry.controller?.destroy();instances.delete(root);}};
 // Observation is optional: failures must not prevent the product Try On listener.
 let observer=null,fallbackNeeded=false,fallbackTimer=null;
 const fallbackScan=()=>{if(!pageActive||document.hidden)return;try{cleanup();}catch{}try{syncCards();}catch{}};
 const stopFallback=()=>{if(fallbackTimer!==null){try{window.clearInterval(fallbackTimer);fallbackTimer=null;}catch{}}};
 const startFallback=()=>{if(!fallbackNeeded||fallbackTimer!==null||!pageActive||document.hidden)return;fallbackScan();try{fallbackTimer=window.setInterval(fallbackScan,2000);}catch{}};
 try{
  if(typeof MutationObserver!=='function')throw Error('observer_unavailable');
  observer=new MutationObserver(records=>{if(records.some(record=>record.addedNodes.length||record.removedNodes.length)){cleanup();syncCards();}});
  observer.observe(document.documentElement,{childList:true,subtree:true});
 }catch{try{observer?.disconnect();}catch{}fallbackNeeded=true;}
 try{syncCards();}catch{}
 if(fallbackNeeded){try{document.addEventListener('visibilitychange',()=>{if(document.hidden)stopFallback();else startFallback();});}catch{}startFallback();}
 // Asset loads are bounded and recoverable. A stale attempt must not clear a newer one.
 const loadStyle=url=>{
  if(styles.has(url))return styles.get(url);
  let link, timer, promise;
  promise=new Promise((resolve,reject)=>{
   link=document.createElement('link');
   let settled=false;
   const finish=error=>{
    if(settled)return;settled=true;clearTimeout(timer);link.onload=null;link.onerror=null;
    if(error){if(styles.get(url)===promise)styles.delete(url);try{link.remove();}catch{}reject(error);}else resolve();
   };
   timer=setTimeout(()=>finish(Error('style_timeout')),15000);
   link.rel='stylesheet';link.href=url;link.onload=()=>finish();link.onerror=()=>finish(Error('style_load'));
   try{document.head.append(link);}catch{finish(Error('style_load'));}
  });
  styles.set(url,promise);
  // A synchronous DOM failure can reject before the map entry is assigned.
  promise.catch(()=>{if(styles.get(url)===promise)styles.delete(url);});
  return promise;
 };
 const loadModule=url=>{
  if(moduleRetryExhausted.has(url)){const failure=Error('module_retry_exhausted');failure.tryonCode=moduleRetryExhausted.get(url);return Promise.reject(failure);}
  if(modules.has(url))return modules.get(url);
  const retry=moduleRetryUsed.has(url);
  let moduleUrl=url;
  if(retry){const parsed=new URL(url,location.href);parsed.searchParams.set('elookus_retry','1');moduleUrl=parsed.href;}
  let timer,promise;
  const timeout=new Promise((_,reject)=>{timer=setTimeout(()=>reject(Error('module_timeout')),15000);});
  promise=Promise.race([Promise.resolve().then(()=>import(moduleUrl)),timeout]).catch(error=>{
   if(modules.get(url)===promise)modules.delete(url);
   if(retry){const failure=Error('module_retry_exhausted');failure.tryonCode=error?.message==='module_timeout'?'T04':'T03';moduleRetryExhausted.set(url,failure.tryonCode);throw failure;}
   moduleRetryUsed.add(url);
   throw error;
  }).finally(()=>clearTimeout(timer));
  modules.set(url,promise);
  return promise;
 };
 // Fixed support codes identify the first observed failing stage only; no error text or data is sent.
 const loadAssets=config=>Promise.all([
  Promise.resolve().then(()=>loadModule(config.module)).catch(error=>{const exhausted=error?.message==='module_retry_exhausted';const failure=Error(exhausted?'module_retry_exhausted':'module_load');failure.tryonCode=error?.tryonCode==='T04'||error?.message==='module_timeout'?'T04':'T03';throw failure;}),
  Promise.resolve().then(()=>loadStyle(config.css)).catch(error=>{const failure=Error('style_load');failure.tryonCode=error?.message==='style_timeout'?'T02':'T01';throw failure;})
 ]);
 document.addEventListener('click',async event=>{
  if(!pageActive)return;
  const button=event.target.closest('[data-elookus-tryon-open]');if(!button)return;
  const root=button.closest('[data-elookus-tryon]');if(!root||disposedRoots.has(root))return;
  event.preventDefault();event.stopPropagation();cleanup();
  const ticket=++openTicket,pageTicket=lifecycle,isCard=root.hasAttribute('data-elookus-tryon-card'),mountRoot=isCard?document.querySelector('[data-elookus-tryon-shared]'):root;
  if(!mountRoot)return;
  const original=button.innerHTML,error=root.querySelector('[data-elookus-tryon-error]');
  let config,initialFrame;
  try{
   config=isCard?{...readConfig(mountRoot),...readConfig(root)}:readConfig(root);
   if(!config||!config.i18n||typeof config.module!=='string'||typeof config.css!=='string')throw Error('invalid_config');
   initialFrame=resolveFrame(root,config);
  }catch{if(error){error.textContent='Try-on could not open. Please try again. (Code: T06)';error.hidden=false;}return;}
  if(!error)return;
  error.hidden=true;
  if(initialFrame===null){syncCard(root);error.textContent=config.i18n.frame_unavailable;error.hidden=false;return;}
  current?.close();current=null;
  let entry=instances.get(mountRoot);
  button.disabled=true;button.setAttribute('aria-busy','true');button.textContent=config.i18n.trigger_loading;
  try{
   if(!entry){
    entry={controller:null,disposed:false,pending:null};instances.set(mountRoot,entry);
    entry.pending=loadAssets(config).then(([mod])=>{
     if(entry.disposed||!mountRoot.isConnected||instances.get(mountRoot)!==entry)return null;
     return entry.controller=mod.mountTryOn(mountRoot,config);
    }).catch(error=>{if(instances.get(mountRoot)===entry)instances.delete(mountRoot);throw error;});
   }
   await entry.pending;
   if(ticket!==openTicket||pageTicket!==lifecycle||!pageActive||!root.isConnected||entry.disposed||!entry.controller)return;
   const selectedFrame=resolveFrame(root,config);
   if(selectedFrame===null){syncCard(root);error.textContent=config.i18n.frame_unavailable;error.hidden=false;return;}
   current=entry.controller;current.open(button,selectedFrame);
  }catch(failure){
   if(entry){entry.disposed=true;entry.controller?.destroy();if(instances.get(mountRoot)===entry)instances.delete(mountRoot);if(current===entry.controller)current=null;}
   if(root.isConnected&&ticket===openTicket){behaviorFailure(root);const unsupported=failure?.message==='unsupported_dialog'||failure?.message==='canvas_unsupported';const code=unsupported?'T05':['T01','T02','T03','T04'].includes(failure?.tryonCode)?failure.tryonCode:'T07';const message=unsupported?'Try On is unavailable in this browser. Please try another browser or continue shopping.':failure?.message==='module_retry_exhausted'?"Try On couldn't load. Refresh this page to try again, or continue shopping.":config.i18n.trigger_error;error.textContent=message+' (Code: '+code+')';error.hidden=false;}
  }finally{if(root.isConnected){button.disabled=false;button.removeAttribute('aria-busy');button.innerHTML=original;}}
 },true);
 document.addEventListener('shopify:section:unload',event=>{
  openTicket++;for(const[root,entry]of instances)if(event.target.contains(root)){entry.disposed=true;disposedRoots.add(root);entry.controller?.destroy();instances.delete(root);}
  if(event.target.querySelector('[data-elookus-tryon-card]'))current?.close();
 });
 window.addEventListener('pageshow',()=>{pageActive=true;try{syncCards();}catch{}startFallback();});
 window.addEventListener('pagehide',()=>{pageActive=false;stopFallback();lifecycle++;openTicket++;for(const entry of instances.values())entry.controller?.close();});
})();
